import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const CLUBS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./clubs-entry/clubs-entry.component').then(m => m.ClubsEntryComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'regulation',
    loadComponent: () => import('./clubs-regulation/clubs-regulation.component').then(m => m.ClubsRegulationComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  }
];
